import { useLoading } from 'Hooks/useLoading'
import React from 'react'
import styled from 'styled-components'

const LoadingBarWrapper = styled.div`
  position: relative;
  height: 30px;
  width: 100%;
  border: 2px solid #b6d7ce;
  background-color: #b6d7ce;
  border-radius: 5px;
`

const Bar = styled.div<{ percentage: number, backgroundColor?: string }>`
  position: absolute;
  height: 100%;
  width: ${props => props.percentage}%;
  background-color: ${props => props.backgroundColor ?? props.theme.colors.primary};
  border-radius: 5px;
  transition: width 0.5s ease-out;
`

const Percentage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
`

interface InitialLoadingProps {
  onCompleted: () => void
  duration?: number // in ms
  backgroundColor?: string
}

const LoadingBar: React.FC<InitialLoadingProps> = ({ onCompleted, duration = 5000, backgroundColor }) => {
  const { percentage, roundedPercentage } = useLoading({ duration, onComplete: onCompleted })

  return (
    <LoadingBarWrapper>
      <Bar percentage={percentage} backgroundColor={backgroundColor} />
      <Percentage>{`${roundedPercentage}%`}</Percentage>
    </LoadingBarWrapper>
  )
}

export default LoadingBar
